import { RouteObject } from '@suntex.core/nav'
import { EntityLevel } from '@suntex.fim/enums'
import { RequireAuth } from '@suntex.fim/framework'
import { TeamLayout, teamPlayRoute } from '@suntex.fim/nav'

import AssessmentReportLayout from '../pages/app/AssessmentReport/AssessmentReportLayout'
import Dashboard from '../pages/app/Dashboard'
import Correlations from '../pages/app/SuggestContent/Correlations'
import FocusMode from '../pages/app/SuggestContent/FocusMode'
import TeamMovePlayers from '../pages/app/TeamManagement/TeamMovePlayers'
import TeamPrintLogins from '../pages/app/TeamManagement/TeamPrintLogins'
import TeamRoster from '../pages/app/TeamManagement/TeamRoster'
import TeamRosterAddMultiple from '../pages/app/TeamManagement/TeamRosterAddMultiple'

import { layoutChrome } from './navChrome'
import { getRankingRoutes } from './rankingsRoutes'
import { getAssessmentReportRoutes, getCommonRoutes } from './routeHelpers'

export const teamRoutes: RouteObject[] = [
  {
    path: '/team/:teamId',
    element: <RequireAuth />,
    children: [
      {
        element: <TeamLayout {...layoutChrome} />,
        children: [
          {
            path: 'dashboard',
            Component: Dashboard
          },
          {
            path: 'assessment-report',
            Component: AssessmentReportLayout,
            children: getAssessmentReportRoutes(EntityLevel.Team)
          },
          {
            path: 'suggest-content/correlations',
            Component: Correlations
          },
          {
            path: 'focus',
            Component: FocusMode
          },
          ...getCommonRoutes(EntityLevel.Team),
          ...getRankingRoutes(EntityLevel.Team),
          {
            path: 'team-management/team-roster',
            Component: TeamRoster
          },
          {
            path: 'team-management/print-logins',
            Component: TeamPrintLogins
          },
          {
            path: 'team-management/add-multiple-students',
            Component: TeamRosterAddMultiple
          },
          {
            path: 'team-management/move-players',
            Component: TeamMovePlayers
          },
          teamPlayRoute
        ]
      }
    ]
  }
]
